export default "__VITE_ASSET__D7dN9tX4__"